import * as React from "react";
const SvgPlusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 0H7V7H0V9H7V16H9V9H16V7H9V0Z", fill: "currentColor" }));
export default SvgPlusIcon;
